import { GetMoneySource } from "@/dto/bank/response/BankInfo";

/**
 * Lấy tài khoản mặc định để debit/transfer.
 * Ưu tiên `defaultTransfer === true`, fallback về phần tử đầu tiên.
 */
export const getDefaultTransferSource = (
  sources: GetMoneySource[] | undefined,
): GetMoneySource | undefined => {
  if (!sources?.length) return undefined;
  return sources.find((s) => s.defaultTransfer) ?? sources[0];
};

/**
 * Chỉ giữ tài khoản VND — dùng cho các nghiệp vụ TRONG NƯỚC (giải ngân, chuyển tiền theo lô…).
 * Tài khoản ngoại tệ (USD…) chỉ dành cho giao dịch quốc tế và mua bán ngoại tệ, đưa vào dropdown
 * trong nước là cho user chọn rồi mới báo lỗi.
 *
 * Tài khoản không gắn `currency` coi như VND (dữ liệu cũ không phải lúc nào cũng có trường này).
 */
export const filterVndSources = (
  sources: GetMoneySource[] | undefined,
): GetMoneySource[] =>
  (sources ?? []).filter((s) => (s.currency || "VND").toUpperCase() === "VND");
